// Documents and exports are never linked to directly — the bytes come back
// through the API with the caller's token, so a download is always a blob
// we have already fetched. Revoking the object URL matters: without it the
// blob stays in memory for the life of the tab, and a vault page can hand
// out a lot of blobs.
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
